// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2rz-X","menuContainer":"styles_menuContainer__3JlRM","menuIcons":"styles_menuIcons__3H1WV"};